import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLifecycles } from 'react-use';
import { Box } from '@mui/system';
import { getRobots, selectRobot, init } from '../modules/historyBot';
import {
  getManagerMode,
  getManagerRobotId,
  getManagerRobotSerial,
  getSerials,
  getUserPId,
} from '../common/util';
import { piboDisconnect, piboInit } from '../pibo';
import NewPage from '../components/NewPage';
import HistoryRobotList from '../components/history/HistoryRobotList';
import HistoryListContainer from '../containers/history/HistoryListContainer';

const HistoryPage = () => {
  const dispatch = useDispatch();
  const historyBot = useSelector((state) => state.historyBot);
  const { robots, errorRobots, loading, selectedRobot } = historyBot;
  const bManagerMode = getManagerMode();

  const handleOpen = (item) => {
    if (!selectedRobot || selectedRobot.id !== item.id) {
      dispatch(selectRobot(item));
    }
  };

  useLifecycles(
    () => {
      if (bManagerMode) {
        handleOpen({
          serial: getManagerRobotSerial(),
          id: getManagerRobotId(),
        });
      } else {
        dispatch(getRobots({ userId: getUserPId() }));
        piboInit(getSerials());
      }
    },
    () => {
      dispatch(init());
      piboDisconnect();
    },
  );

  return (
    <NewPage title="히스토리">
      <Grid item xs={12}>
        <Card>
          {!bManagerMode && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                m: 2,
              }}
            >
              <Typography variant="h5">로봇 목록</Typography>
            </Box>
          )}
          <CardContent>
            <Grid container spacing={2}>
              {!bManagerMode && (
                <Grid item xs={12} md={6}>
                  <HistoryRobotList
                    {...{
                      loading,
                      robots,
                      errorRobots,
                      selectedRobot,
                      handleOpen,
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12} md={6}>
                {((!bManagerMode && robots && robots.length > 0) ||
                  bManagerMode) && <HistoryListContainer />}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </NewPage>
  );
};

export default HistoryPage;
